
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import { ProcessedGuard } from "./types";

interface ResultsListProps {
  items: ProcessedGuard[];
  icon: React.ReactNode;
  emptyMessage: string;
  showError?: boolean;
  showWarning?: boolean;
  showAFM?: boolean;
}

export const ResultsList = ({ 
  items, 
  icon, 
  emptyMessage, 
  showError = false, 
  showWarning = false,
  showAFM = false
}: ResultsListProps) => {
  if (items.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <ScrollArea className="h-[400px] rounded-md border p-4">
      <div className="space-y-3">
        {items.map((item, index) => (
          <div 
            key={`${item.name}-${index}`} 
            className="p-3 rounded-lg border bg-slate-50 flex flex-col gap-1"
          >
            <div className="flex items-center gap-2">
              {icon}
              <span className="font-medium">{item.name}</span>
              {showAFM && item.afm && (
                <Badge variant="outline" className="ml-auto">
                  VAT: {item.afm}
                </Badge>
              )}
            </div>
            
            {showError && item.error && (
              <div className="mt-1 text-sm text-red-600 pl-7">
                Error: {item.error}
              </div>
            )}
            
            {showWarning && item.warning && (
              <div className="mt-1 text-sm text-amber-600 pl-7">
                Warning: {item.warning}
              </div>
            )}
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};
